import React, { Component } from "react";
import { connect } from 'react-redux';
import LoginForm from "./LoginForm";
import AuthService from "../../service/AuthService";
import { successLoginAction, logoutAction, AuthenticationState } from "../../reducer/authentication";
import { loadingAction } from "../../reducer/loading";
import { RouteChildrenProps } from "react-router-dom";
import { RootState } from "../../reducer";
import logoBackgrounf from '../../images/logo_commbox_transparent_full.png';
import { PermissionError } from "../../service/Errors";

interface LoginPageProps extends AuthenticationState, RouteChildrenProps {
    successLoginAction: typeof successLoginAction;
    logoutAction: typeof logoutAction;
    loadingAction: typeof loadingAction;
}

interface LoginPageState {
    errorMessage: string | null
}

export interface LoginRequest {
    username: string, password: string
}

class LoginPage extends Component<LoginPageProps, LoginPageState> {

    constructor(props: LoginPageProps) {
        super(props);
        this.onLogin = this.onLogin.bind(this);
        this.state = {
            errorMessage: null
        }
    }

    verifyAuth() {
        var { loggedIn, history, successLoginAction, match } = this.props;
        if (loggedIn) {
            let redirect = '';
            if (match) {
                const queryString = window.location.hash;
                const urlParams = new URLSearchParams(queryString.replace(`#${match.url}?`, ''));
                redirect = urlParams.get('r') || '';
            }
            history.replace('/' + (redirect ? '?r=' + redirect : ''));
        }
    }

    componentDidMount() {
        this.verifyAuth();
    }

    componentDidUpdate() {
        this.verifyAuth();
    }

    async onLogin({ username, password }: LoginRequest) {
        var { successLoginAction, loadingAction, logoutAction } = this.props;
        try {
            loadingAction(true);
            const success = await AuthService.instance.login(username, password);
            if (success) {
                const user = await AuthService.instance.getAuthUser();
                successLoginAction(user);
            }
        } catch (e) {
            var errorMsg = '';
            if (e instanceof PermissionError) {
                errorMsg = e.message;
            } else {
                errorMsg = e instanceof Error ? e.message : String(e);
                if (errorMsg.includes('fetch')) {
                    errorMsg = 'Erro de comunicação com o servidor';
                }
            }
            this.setState({ errorMessage: errorMsg });
            logoutAction();
        } finally {
            loadingAction(false);
        }
    }

    render() {
        const { errorMessage } = this.state;
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                flex: 1,
                backgroundImage: `url(${logoBackgrounf})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
            }}>
                <LoginForm
                    onSubmit={this.onLogin}
                    errorMessage={errorMessage}
                />
            </div>
        );
    }
}

function mapStateToProps(state: RootState) {
    const { authentication } = state;
    return authentication;
}

const mapDispatchToProps = {
    loadingAction,
    successLoginAction,
    logoutAction
};

const connected = connect(mapStateToProps, mapDispatchToProps)(LoginPage);
export default connected;